import { createSlice } from "@reduxjs/toolkit";

import {
  clinicTournamentEngagement,
  getDashboardData,
  getTeamStatisticsData,
  getUserEngagementData,
  getUserStatisticsData,
} from "../../actions/dashboard/dashboardData";
import { userReportData } from "../../actions/reports/reportsData";

const initialState = {
  dashboardData: {
    organization_data: null,
    teams: null,
    user_engagement: null,
    tournament_engagement: null,
    users_tracker_report: null,
    user_statistics: null,
  },
  isDashboardLoading: true,
  loaders: {
    userEngagement: true,
    userTrackerReport: true,
    userStatistics: true,
  },
  reportDataLoading: false,
  reportData: null,
  userStatistics: [],
  userStatisticsLoader: false,
  clinicTourEngLoading: false,
  clinicTourEngData: [],
  orgTournamentList: [],
};

export const dashboardDataSlice = createSlice({
  name: "dashboardData",
  initialState,
  reducers: {
    sidebarLoaderHandler: (state) => {
      state.isDashboardLoading = false;
    },
  },
  extraReducers: {
    // org overview load
    [getDashboardData.pending]: (state) => {
      state.isDashboardLoading = true;
    },
    [getDashboardData.fulfilled]: (state, { payload }) => {
      state.isDashboardLoading = false;
      if (payload.organization_data) {
        state.dashboardData.organization_data = payload.organization_data;
      }
      if (payload.teams) {
        state.dashboardData.teams = payload.teams;
      }
      if (payload.tournament_engagement) {
        state.dashboardData.tournament_engagement =
          payload.tournament_engagement;
      }
      if (payload.tournaments) {
        state.orgTournamentList = payload.tournaments;
      }
    },
    [getDashboardData.rejected]: (state, { error }) => {
      state.isDashboardLoading = false;
    },
    // user engagement overview load
    [getUserEngagementData.pending]: (state) => {
      state.loaders.userEngagement = true;
    },
    [getUserEngagementData.fulfilled]: (state, { payload }) => {
      state.loaders.userEngagement = false;
      if (payload) {
        state.dashboardData.user_engagement = payload;
      }
    },
    [getUserEngagementData.rejected]: (state, { error }) => {
      state.loaders.userEngagement = false;
    },
    // user tracker report data load
    [getUserStatisticsData.pending]: (state) => {
      state.loaders.userStatistics = true;
    },
    [getUserStatisticsData.fulfilled]: (state, { payload }) => {
      state.loaders.userStatistics = false;
      if (payload) {
        state.dashboardData.user_statistics = payload;
      }
    },
    [getUserStatisticsData.rejected]: (state, { error }) => {
      state.loaders.userStatistics = false;
    },
    // User report load
    [userReportData.pending]: (state) => {
      state.reportDataLoading = true;
    },
    [userReportData.fulfilled]: (state, { payload }) => {
      state.reportDataLoading = false;
      state.reportData = payload;
    },
    [userReportData.rejected]: (state, { error }) => {
      state.reportDataLoading = false;
    },
    // Team statistics load
    [getTeamStatisticsData.pending]: (state, { error }) => {
      state.userStatisticsLoader = true;
    },
    [getTeamStatisticsData.fulfilled]: (state, { payload }) => {
      state.userStatisticsLoader = false;
      state.userStatistics = payload.teams_statistics;
    },
    [getTeamStatisticsData.rejected]: (state, { error }) => {
      state.userStatisticsLoader = false;
    },
    [clinicTournamentEngagement.pending]: (state) => {
      state.clinicTourEngLoading = true;
    },
    [clinicTournamentEngagement.fulfilled]: (state, { payload }) => {
      state.clinicTourEngData = payload;
      // state.clinicTourEngData.contest_dates = ["2024-05-16", "2024-06-16"];
      // state.clinicTourEngData.contest_participation_data = {
      //   "2024-05-16": {
      //     "Banerjee Kidney Center LLC": {
      //       participated: 10,
      //       not_participated: 28
      //     },
      //     blaze: {
      //       participated: 20,
      //       not_participated: 28
      //     },
      //     "DTProduct -India": {
      //       participated: 20,
      //       not_participated: 28
      //     },
      //     "Minneapolis Community Connection Hospital": {
      //       participated: 20,
      //       not_participated: 28
      //     }
      //   },
      //   "2024-06-16": {
      //     "Banerjee Kidney Center LLC": {
      //       participated: 5,
      //       not_participated: 28
      //     },
      //     blaze: {
      //       participated: 15,
      //       not_participated: 28
      //     },
      //     "DTProduct -India": {
      //       participated: 20,
      //       not_participated: 28
      //     },
      //     "Minneapolis Community Connection Hospital": {
      //       participated: 20,
      //       not_participated: 28
      //     }
      //   }
      // };
      state.clinicTourEngLoading = false;
    },
    [clinicTournamentEngagement.rejected]: (state) => {
      state.clinicTourEngLoading = false;
      state.clinicTourEngData = [];
    },
  },
});

export const { sidebarLoaderHandler } = dashboardDataSlice.actions;

export default dashboardDataSlice.reducer;
